(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peak-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('peak-editorial-video')) {
    customElements.define('peak-editorial-video', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.controls = false;
        button.hidden = false;
        const sync = () => { button.textContent = video.paused ? this.dataset.play : this.dataset.pause; };
        button.addEventListener('click', () => { if (video.paused) video.play().catch(sync); else video.pause(); });
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
        video.addEventListener('error', sync);
        if (reducedMotion.matches || navigator.connection?.saveData) { video.autoplay = false; video.pause(); }
        else { video.autoplay = true; video.play().catch(sync); }
        reducedMotion.addEventListener('change', event => { if (event.matches) video.pause(); });
        sync();
      }
    });
  }
  if (!customElements.get('peak-editorial-chat')) {
    customElements.define('peak-editorial-chat', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.querySelector('button').addEventListener('click', () => {
          clearTimeout(this.timer);
          const status = this.querySelector('[role=status]');
          status.hidden = true;
          let attempts = 0;
          const open = () => {
            const chat = document.querySelector('shopify-chat');
            if (chat && typeof chat.show === 'function') { chat.show(); return; }
            if (++attempts < 32) this.timer = setTimeout(open, 250);
            else status.hidden = false;
          };
          open();
        });
      }
      disconnectedCallback() { clearTimeout(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peak-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('peak-hero-video')) {
    customElements.define('peak-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button || this.initialized) return;
        this.initialized = true;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.video.controls = false;
        this.video.muted = true;
        this.video.playsInline = true;
        this.button.hidden = false;
        this.sync = () => { this.button.textContent = this.video.paused ? this.dataset.play : this.dataset.pause; };
        this.toggle = () => {
          if (this.video.paused) this.video.play().catch(this.sync);
          else this.video.pause();
        };
        this.reduce = () => { if (this.motion.matches) this.video.pause(); };
        this.button.addEventListener('click', this.toggle);
        this.video.addEventListener('play', this.sync);
        this.video.addEventListener('pause', this.sync);
        this.motion.addEventListener('change', this.reduce);
        if (!this.motion.matches && !navigator.connection?.saveData) this.video.play().catch(this.sync);
      }
      disconnectedCallback() {
        if (!this.initialized) return;
        this.video.pause();
        this.button.removeEventListener('click', this.toggle);
        this.video.removeEventListener('play', this.sync);
        this.video.removeEventListener('pause', this.sync);
        this.motion.removeEventListener('change', this.reduce);
        this.initialized = false;
      }
    });
  }

if (!customElements.get('peak-optician-chat')) {
  customElements.define('peak-optician-chat', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelector('button').addEventListener('click', async () => {
        const button = this.querySelector('button');
        const status = this.querySelector('[role="status"]');
        status.hidden = true;
        button.disabled = true;
        let attempts = 0;
        const openChat = () => {
          if (!this.isConnected) return;
          const chat = document.querySelector('shopify-chat');
          if (chat && typeof chat.show === 'function') {
            chat.show();
            button.disabled = false;
          } else if (++attempts < 32) {
            window.setTimeout(openChat, 250);
          } else {
            button.disabled = false;
            status.hidden = false;
          }
        };
        openChat();
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peak-newsletter-popup"]) return;
  try {
    
if(!customElements.get('peak-newsletter-popup')){
  customElements.define('peak-newsletter-popup',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      const dialog=this.querySelector('dialog');
      const close=()=>dialog.close();
      this.querySelector('.peak-signup__close').addEventListener('click',close);
      this.querySelector('.peak-signup__dismiss').addEventListener('click',close);
      dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close()}});
      const open=()=>{if(this.isConnected&&!dialog.open&&typeof dialog.showModal==='function')dialog.showModal()};
      const sessionKey='peak-newsletter-shown-v1';
      let shown=false;
      try{shown=sessionStorage.getItem(sessionKey)==='true'}catch(e){}
      const result=this.querySelector('[data-signup-success],[data-signup-error]');
      const preview=new URLSearchParams(location.search).get('peak_popup')==='preview';
      if(!shown||result||preview||this.dataset.editor==='true'){
        setTimeout(()=>{
          open();
          if(dialog.open){try{sessionStorage.setItem(sessionKey,'true')}catch(e){}}
        },3000);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peak-prescription-lenses"]) return;
  try {
    
if (!customElements.get('peak-lens-chat')) {
  customElements.define('peak-lens-chat', class extends HTMLElement {
    connectedCallback() {
      if (this.onChatClick) return;
      this.onChatClick = (event) => {
        const button = event.target.closest('button[data-peak-lens-chat]');
        if (!button || !this.contains(button)) return;
        const status = this.querySelector('[data-chat-status]');
        status.hidden = true;
        button.disabled = true;
        let attempts = 0;
        const openChat = () => {
          if (!this.isConnected) { button.disabled = false; return; }
          const chat = document.querySelector('shopify-chat');
          if (chat && typeof chat.show === 'function') {
            chat.show();
            button.disabled = false;
          } else if (++attempts < 32) {
            window.setTimeout(openChat, 250);
          } else {
            button.disabled = false;
            button.insertAdjacentElement('afterend', status);
            status.hidden = false;
          }
        };
        openChat();
      };
      this.addEventListener('click', this.onChatClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onChatClick);
      this.onChatClick = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peak-seo-page"]) return;
  try {
    
if (!customElements.get('peak-seo-page')) {
  customElements.define('peak-seo-page', class extends HTMLElement {
    connectedCallback() {
      if (this.chatHandler) return;
      this.chatHandler = (event) => {
        const link = event.target.closest('[data-peak-seo-chat]');
        if (!link || !this.contains(link)) return;
        event.preventDefault();
        const status = this.querySelector('[data-chat-status]');
        status.hidden = true;
        let attempts = 0;
        clearTimeout(this.chatTimer);
        const open = () => {
          if (!this.isConnected) return;
          const chat = document.querySelector('shopify-chat');
          if (chat && typeof chat.show === 'function') chat.show();
          else if (++attempts < 32) this.chatTimer = setTimeout(open, 250);
          else { link.insertAdjacentElement('afterend', status); status.hidden = false; }
        };
        open();
      };
      this.addEventListener('click', this.chatHandler);
    }
    disconnectedCallback() {
      clearTimeout(this.chatTimer);
      this.removeEventListener('click', this.chatHandler);
      this.chatHandler = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
